import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'

import metaEnv from '../../../helper/metaEnv'
import { logout } from '../../../utilitie/Auth'
import {
  ADMIN_SESSION_EXPIRED_EVENT,
  hasAdminSessionExpired,
} from '../../../service/auth/adminSessionEvents'

export default function AdminSessionExpiredDialog() {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(hasAdminSessionExpired)

  useEffect(() => {
    const handleSessionExpired = () => setOpen(true)

    window.addEventListener(ADMIN_SESSION_EXPIRED_EVENT, handleSessionExpired)
    if (hasAdminSessionExpired()) handleSessionExpired()
    return () => window.removeEventListener(ADMIN_SESSION_EXPIRED_EVENT, handleSessionExpired)
  }, [])

  const handleLoginAgain = () => {
    logout()
    const basePath = metaEnv.basepath.replace(/\/+$/, '')
    const loginPath = basePath ? `${basePath}/login` : '/login'
    window.location.assign(loginPath)
  }

  // The delivery-route-info screen is intentionally allowed to remain usable
  // while the temporary session UX is being reviewed. The API/auth guards
  // remain unchanged; only this blocking dialog is suppressed on that route.
  if (pathname.endsWith('/delivery-route-info')) return null

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>เซสชันหมดอายุ</DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning">
          <AlertTitle>กรุณาเข้าสู่ระบบใหม่</AlertTitle>
          เซสชันผู้ดูแลระบบหมดอายุหรือไม่สามารถใช้งานต่อได้
          ระบบจะล้างข้อมูลการเข้าสู่ระบบเดิมเมื่อคุณกดปุ่มด้านล่าง
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleLoginAgain} autoFocus>
          เข้าสู่ระบบใหม่
        </Button>
      </DialogActions>
    </Dialog>
  )
}
